import React from 'react'
import Modal from '../Modal'
import * as S from './styles'

interface Props {
  show: boolean;
  title: string;
  message?: string;
  action: () => void;
  centered?: boolean;
  customizableBody?: JSX.Element
  testId?: string
  closeButtonAction?: () => void
  okButtonDisabled?: boolean
  closeButtonDisabled?: boolean
}

const ModalAlert = ({
  show,
  title,
  message = '',
  action,
  centered = false,
  customizableBody,
  testId,
  closeButtonAction,
  okButtonDisabled = false,
  closeButtonDisabled = false,
}: Props) => (
  <Modal
    show={show}
    title={title}
    closeButtonAction={closeButtonAction || action}
    closeButtonDisabled={closeButtonDisabled}
    centered={centered}
    body={(
      <>
        {customizableBody || <h5 style={{ padding: '1rem' }}>{message}</h5>}
        <S.ButtonContainer>
          <S.ConfirmButton
            onClick={action}
            type='button'
            data-testid='ok-button-test-id'
            disabled={okButtonDisabled}
          >
            OK
          </S.ConfirmButton>
        </S.ButtonContainer>
      </>
    )}
    testId={testId}
  />
)

export default ModalAlert
